import React from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
// import { Box } from '@mui/system';
import Button from '@mui/material/Button';
import { useState } from 'react';
import { useLocation } from 'react-router';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { postDocumentReupload } from '../Axios/Reupload';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

// const ImageBox = styled('div')({
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100%',
//     width: '100%',
//     borderRadius: '10px',
//     backgroundColor: '#f7f7f7',
//     padding: '20px',
//     cursor: 'pointer',
//     '&:hover': {
//         backgroundColor: '#ddd',
//     },
// })

const ReuploadPage = () => {
  const [UploadedImage, setUploadedImage] = useState(null);
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [alertType, setAlertType] = useState('success');
  const [AlertMessage, setAlertMessage] = useState(null);
  const [OpenLoader, setOpenLoader] = useState(false);
  const [Size, setSize] = useState(false);
  const [Type, setType] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
    setType(false);
    setSize(false);
  };

  const handleOpenLoader = () => {
    setOpenLoader(true);
  };

  const handleCloseLoader = () => {
    setOpenLoader(false);
  };

  console.log('location', location.state);

  const data = location.state;
  const check = () => {
    for (const [key, value] of Object.entries(data)) {
      console.log('key', key, value);

      if (UploadedImage === null || (key !== 'user_id' && !UploadedImage[key])) {
        console.log('false');
        return false;
      }
    }

    return true;
  };
  const handleFormSubmit = () => {
    let status = check();
    console.log(status);
    if (status === true && UploadedImage !== null) {
      console.log(UploadedImage);
      postDocumentReupload(UploadedImage, setAlertMessage, setAlertType, handleClick, handleOpenLoader, handleCloseLoader);
    } else {
      setAlertMessage('Upload all the documents');
      setAlertType('error');
      handleClick();
    }
  };
  function formatLabel(label) {
    // Replace underscores with spaces, then capitalize the first letter of each word
    return label
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  }
  const hanfleFilUpload = (name, file) => {
    const maxSize = 5 * 1024 * 1024;
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    if (file.size >= maxSize) {
      setSize(true);
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      setType(true);
      return;
    }
    setUploadedImage({ ...UploadedImage, [name]: file });
  };
  return (
    <Grid container height="100vh" alignItems="center" justifyContent="center" sx={{ backgroundColor: '#eee6f2' }}>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={OpenLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {AlertMessage}
        </Alert>
      </Snackbar>
      <Snackbar open={Type} autoHideDuration={5000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleClose} variant="filled" severity="error" sx={{ width: '100%' }}>
          Only PDF, JPG, JPEG, and PNG files are allowed.
        </Alert>
      </Snackbar>
      <Snackbar open={Size} autoHideDuration={5000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleClose} variant="filled" severity="error" sx={{ width: '100%' }}>
          File size should not exceed 5MB.
        </Alert>
      </Snackbar>
      <Grid item xl={3} lg={3} md={3} sm={3} xs={3} paddingInline={2}>
        <Typography variant="h4">Documents Requested</Typography>
        <ol>
          {data &&
            Object.entries(data).map(([key]) =>
              key !== 'user_id' ? (
                <li key={key}>
                  <Typography variant="h5">{formatLabel(key)}</Typography>
                </li>
              ) : null
            )}
        </ol>
      </Grid>
      <Grid item xl={9} lg={9} md={9} sm={9} xs={9} sx={{ backgroundColor: '#fff' }} height="100%" padding={3}>
        <Typography variant="h3" mb={3}>
          Reupload Documents
        </Typography>
        <Typography gutterBottom variant="h3" mb={3} sx={{ color: 'red', fontSize: '13px' }}>
          Note: jpg,jpeg,png,pdf only accept (size: below 5mb)
        </Typography>
        <Grid container spacing={2}>
          {data &&
            Object.entries(data).map(([key]) =>
              key !== 'user_id' ? (
                <Grid item xl={4} height="20%" key={key}>
                  <TextField
                    id="outlined-basic"
                    label={formatLabel(key)}
                    value={UploadedImage && UploadedImage[key] ? UploadedImage[key].name : ''}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <Button component="label" role={undefined} variant="contained" tabIndex={-1} color="secondary">
                            Upload
                            <VisuallyHiddenInput
                              accept=".pdf,.jpg,.jpeg,.png"
                              onChange={(e) => hanfleFilUpload(key, e.target.files[0])}
                              type="file"
                            />
                          </Button>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
              ) : null
            )}
        </Grid>
        <Grid item xl={12} mt={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button variant="contained" size="large" color="secondary" onClick={() => handleFormSubmit()}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReuploadPage;
